import React, { useEffect } from 'react'
import { Dispatch, RootState } from 'src/store'
import { AuthRoute, FlexRoutes } from 'src/routes'
import CompanyConfigurations from 'src/companies/configurations/index'
import CompanyTranslator from 'src/companies/translator'
import CompanyCashBids from 'src/companies/cashbids'
import CompanyPositions from 'src/companies/positions'
import CommoditiesRouter from 'src/companies/commodities/router'
import { Navigate, Route } from 'react-router-dom'
import { CompanyProvider } from './company-context'
import LocationsRouter from 'src/companies/locations/router'
import MarketsIndex from 'src/companies/markets'
import Subscriptions from 'src/companies/subscriptions/index'

export * from 'src/companies/routes/companies-default'
export * from 'src/companies/routes/helpers'
export * from 'src/companies/routes/validators'

interface CompanyRoutesProps {
  env: string
  slug: string
  company: Company
  companies: RootState['companies']
  setSettingsState: Dispatch['settings']['setState']
}

function CompanyRoutes({ env, slug, company, companies, setSettingsState }: CompanyRoutesProps) {
  useEffect(() => {
    setSettingsState({ showCompanySelectorDialog: true, showCentreEnvironment: true })
  }, [setSettingsState])

  return (
    // relative to /companies/:env/:slug/*
    <CompanyProvider company={company}>
      <FlexRoutes>
        <Route path="/markets/*" element={<AuthRoute as={MarketsIndex} />} />
        <Route path="/subscriptions" element={<AuthRoute as={Subscriptions} env={env} />} />
        <Route
          path="/configurations"
          element={
            <AuthRoute as={CompanyConfigurations} company={company} companies={companies.data} />
          }
        />
        <Route
          path="/translator"
          element={
            <AuthRoute as={CompanyTranslator} company={company} companies={companies.data} />
          }
        />
        <Route
          path="/locations/*"
          element={<AuthRoute as={LocationsRouter} company={company} companies={companies.data} />}
        />
        <Route
          path="/cash-bid-config"
          element={<AuthRoute as={CompanyCashBids} company={company} companies={companies.data} />}
        />
        <Route
          path="/positions/*"
          element={<AuthRoute as={CompanyPositions} company={company} />}
        />
        <Route
          path="/commodities/*"
          element={
            <AuthRoute
              as={CommoditiesRouter}
              company={company}
              companies={companies.data}
              env={env}
            />
          }
        />
        <Route
          path="*"
          element={
            <AuthRoute
              as={() => <Navigate to={`/companies/${env}/${slug}/configurations`} replace />}
              env={env}
              slug={slug}
            />
          }
        />
      </FlexRoutes>
    </CompanyProvider>
  )
}

export default CompanyRoutes
